/* Components */
import Header from "../../components/common/Header";
import ViewFunerariumGeneralInfos from "./funerarium/ViewFunerariumGeneralInfos";
import ViewFunerariumAddress from "./funerarium/ViewFunerariumAddress";
import ViewFunerariumSchedule from "./funerarium/ViewFunerariumSchedule";
import {getFunerariumGeneralInfos} from "../../api/pro/funerariumReq";
import useData from "../../hooks/useData";
import useAuth from "../../hooks/useAuth";
import jwt_decode from "jwt-decode";
import {useEffect} from "react";


export default function ViewFunerarium() {
    const { auth } = useAuth();
    const token = auth.token;
    const decodedToken = jwt_decode(token);
    const agencyId = decodedToken.agency;
    const { funerariumInfos, setFunerariumInfos } = useData();

    const apiFunerariumGeneralInfos = async () => {
        const response = await getFunerariumGeneralInfos(token, agencyId);
        setFunerariumInfos(response);
    }

    useEffect(() => {
        if (funerariumInfos?.length < 1) {
            apiFunerariumGeneralInfos();
        }
    }, [ funerariumInfos ]);

    return (
        <main>
            <Header parent="Funerarium"
                    location="Le funérarium"
                    slug={`/funerarium/`}
            />
            <ViewFunerariumGeneralInfos apiFunerariumGeneralInfos={apiFunerariumGeneralInfos} legend="Funérarium"/>
            <ViewFunerariumAddress apiFunerariumGeneralInfos={apiFunerariumGeneralInfos} legend="Adresse"/>
            <ViewFunerariumSchedule apiFunerariumGeneralInfos={apiFunerariumGeneralInfos} legend="Horaires d'ouverture"/>
        </main>
    )
}